const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/intake/ideas/create/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/intake/ideas/create/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.ideaManagement.general.createIdea)
    },
    launchCreate: true
  }
});